var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content warehouse-home" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": _vm.configModule,
                  reset: true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.filter.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.arriveStorageClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Warehouse.WarehouseIn")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.deliverClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Warehouse.WarehouseOut")))]
                    ),
                    _vm.privilege.charge.chargeView
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !_vm.selectRow,
                              type: "primary"
                            },
                            on: { click: _vm.chargeClickHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Charge")))]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.warehouseClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Warehouse.NewWarehouseFee")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onPrint }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": _vm.configModule,
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "wrap-text": true,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": _vm.configModule,
                    total: _vm.total,
                    page: _vm.filterJson.pageNum,
                    limit: _vm.filterJson.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filterJson, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filterJson, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("cargo-template-select-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "printed-callback": _vm.templateSelectorDialog.printedCallback,
          "v2-check-callback": _vm.templateSelectorDialog.printedCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("upload-common-file", {
        attrs: {
          visible: _vm.uploadCommonFileDialog.visible,
          model: _vm.uploadCommonFileDialog.model,
          "document-category": _vm.documentCategory
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFileDialog, "visible", $event)
          }
        }
      }),
      _c("in-or-out-warehouse-form", {
        attrs: {
          type: _vm.inOrOutWarehouseDialog.type,
          title: _vm.inOrOutWarehouseDialog.title,
          visible: _vm.inOrOutWarehouseDialog.visible,
          job: _vm.inOrOutWarehouseDialog.job
        },
        on: {
          close: function($event) {
            _vm.inOrOutWarehouseDialog.visible = false
          },
          ok: _vm.onSaveInOrOutState
        }
      }),
      _c("add-warehouse-charge-dialog", {
        attrs: {
          visible: _vm.addWarehouseChargeDialog.visible,
          "job-list": _vm.addWarehouseChargeDialog.jobList
        },
        on: {
          close: function($event) {
            _vm.addWarehouseChargeDialog.visible = false
          }
        }
      }),
      _c("warehouse-charge-dialog", {
        attrs: {
          visible: _vm.chargeDialog.visible,
          job: _vm.chargeDialog.job,
          lob: _vm.lob
        },
        on: {
          close: function($event) {
            _vm.chargeDialog.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }